import { IconProps } from '@models/icons';

function ArrowUpIcon({ size, color, ...rest }: IconProps) {
    return (
        <svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest}>
            <path
                d="M9.40135 18.126C8.03322 19.3501 8.89911 21.6165 10.7349 21.6165L19.2655 21.6165C21.1013 21.6165 21.9672 19.3501 20.5991 18.126L16.3338 14.3097C15.5745 13.6303 14.4259 13.6303 13.6666 14.3097L9.40135 18.126Z"
                fill="#6E6864"/>
        </svg>
    );
}

export default ArrowUpIcon;
